import React from "react";
import ContactInfoWidget from "../Widget/ContactInfoWidget";
import { MenuWidget1, MenuWidget2 } from "../Widget/MenuWidget";
import SocialWidget from "../Widget/SocialWidget";
import Newsletter from "../Widget/Newsletter";
import TextWidget from "../Widget/TextWidget";
const menuDataOne = [
  { title: "About Us", href: "/about" },
  { title: "Contact Us", href: "/contact" },
  { title: "Register", href: "/register" },
  { title: "Terms and Conditions", href: "/terms" },
  { title: "Other Terms and Conditions", href: "/other-terms" },
  { title: "Privacy Policy", href: "/privacy-policies" },
];
const menuDataTwo = [
  { title: "Career"},
  { title: "How NHWM Works", href: "#ourservices" },
  { title: "Product", href: "#ourservices" },
  { title: "Testimonials", href: "#testimonials" },
  { title: "FAQs", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: "url(/images/footer_bg_1.svg)" }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: "url(/images/footer_logo_bg.svg)" }}
        >
          <img
            src="/images/nhwm.png"
            alt="Logo Icon"
            className="cs_footer_brand_icon"
            style={{ width: "140px" }}
          />
          <h2 className="cs_footer_brand_text">NHWM</h2>
        </div>
      </div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <TextWidget text="National Healthcare & <br />Wellness Mission" />
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget2 data={menuDataOne} />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget1 data={menuDataTwo} />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <Newsletter
                  title="Be Our Subscribers"
                  subTitle="To get the latest news about health from our experts"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright © 2024 NHWM. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
